import styled, { css } from 'styled-components'

import FormikForm from '../../form/FormikForm'
import { mq, sizes } from '../../theme'
import FormSubmitButton from '../../form/FormSubmitButton'

export const Filters = styled.div<{ $isOpen?: boolean }>`
  background-color: ${({ theme }) => theme.colors.brownBack};
  padding: 3rem 0;
  display: none;

  @media ${mq(null, sizes.tablet)} {
    padding: 2.5rem 0;
  }

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      display: block;
    `}
`
export const Form = styled(FormikForm)``
export const Fields = styled.div`
  display: flex;
  gap: 7rem;

  @media ${mq(null, sizes.tablet)} {
    gap: 2.5rem;
    flex-direction: column;
  }
`

export const FieldsWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 2rem;
  flex: 1;
`

export const Block = styled.div`
  flex: 1;
`
export const BlockTitle = styled.span`
  display: inline-block;
  ${({ theme }) => theme.textStyles.firaSansLg};
  color: ${({ theme }) => theme.colors.bluePrimary};
  margin-bottom: 4rem;
  position: relative;

  &:after {
    content: '';
    display: inline-block;
    width: 30%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-bottom: 0.2rem solid ${({ theme }) => theme.colors.bluePrimary};
  }
`

export const SubmitBlock = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;
`

export const Submit = styled(FormSubmitButton)``
